import { Typography, makeStyles } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import React, { FunctionComponent } from 'react';
import CodeSample from '@modules/utilities/interfaces/CodeSample';
import CodeBlockV2 from '@modules/ui/codeBlock/components/CodeBlockV2';
import { getEngineRevampHeadingStyle } from '@modules/ui/shared/utils/styles';

const useCodeSamplesStyles = makeStyles()(() => ({
  singleCodeSampleContainer: {
    marginBottom: '36px',
  },
  codeSamplesTitleContainer: {
    marginBottom: '24px',
  },
  codeSamplesTitle: {
    ...getEngineRevampHeadingStyle(),
  },
}));

export interface ReferenceCodeSamplesProps {
  codeSamples: CodeSample[];
}

const ReferenceCodeSamples: FunctionComponent<
  React.PropsWithChildren<ReferenceCodeSamplesProps>
> = ({ codeSamples }) => {
  const { translate } = useTranslation();
  const { classes } = useCodeSamplesStyles();
  const codSampleWithUniqIdentifier = codeSamples.map((item, index) => ({
    ...item,
    identifier: `${item.identifier}=${index}`,
  }));

  return (
    <React.Fragment>
      <div className={classes.codeSamplesTitleContainer}>
        <Typography variant='subtitle2' className={classes.codeSamplesTitle}>
          {translate('Label.CodeSamples')}
        </Typography>
      </div>
      {codSampleWithUniqIdentifier?.map(({ identifier, codeSample, displayName, description }) => (
        <div className={classes.singleCodeSampleContainer} key={identifier}>
          <CodeBlockV2
            content={codeSample ?? ''}
            title={displayName ?? ''}
            language='luau'
            description={description ?? undefined}
            maxContentHeight={400}
            enableCopy
            enableExpand
            showLanguageLabel
          />
        </div>
      ))}
    </React.Fragment>
  );
};

export default ReferenceCodeSamples;
